import { render, staticRenderFns } from "./ScrollingSenders.vue?vue&type=template&id=72292d3c&scoped=true&"
import script from "./ScrollingSenders.vue?vue&type=script&lang=js&"
export * from "./ScrollingSenders.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingSenders.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ScrollingSenders.vue?vue&type=style&index=1&id=72292d3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72292d3c",
  null
  
)

component.options.__file = "ScrollingSenders.vue"
export default component.exports